// Helpers for the export panel: building the export text and providing
// copy / download actions that work on both desktop and mobile browsers.

export function getExportText () {
  try {
    const stored = window.localStorage.getItem('ends')
    if (stored) return stored
  } catch (err) {
    // localStorage may be unavailable (private mode, SSR, etc.)
  }
  return JSON.stringify([])
}

export async function copyText (text, textareaRef) {
  if (
    typeof navigator !== 'undefined' &&
    navigator.clipboard &&
    typeof navigator.clipboard.writeText === 'function'
  ) {
    try {
      await navigator.clipboard.writeText(text)
      return true
    } catch (err) {
      // fall through to legacy path
    }
  }

  const el = textareaRef && textareaRef.current
  if (el && typeof el.select === 'function') {
    try {
      el.focus()
      el.select()
      if (typeof el.setSelectionRange === 'function') {
        el.setSelectionRange(0, text.length)
      }
      if (
        typeof document !== 'undefined' &&
        typeof document.execCommand === 'function'
      ) {
        return document.execCommand('copy')
      }
    } catch (err) {
      // ignore and report failure below
    }
  }

  return false
}

export function downloadJson (text, filename) {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return false
  }
  const name = filename || buildExportFilename()
  const blob = new Blob([text], { type: 'application/json' })
  const url = window.URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = name
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  // Defer revoke so the download has a chance to start in all browsers.
  setTimeout(() => window.URL.revokeObjectURL(url), 0)
  return true
}

export function buildExportFilename (now) {
  const d = now || new Date()
  const pad = n => String(n).padStart(2, '0')
  const stamp =
    d.getFullYear() +
    pad(d.getMonth() + 1) +
    pad(d.getDate()) +
    '-' +
    pad(d.getHours()) +
    pad(d.getMinutes())
  return `archerscore-${stamp}.json`
}
